"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Form = _interopRequireDefault(require("./Form"));
var _InputFeedback = _interopRequireDefault(require("./InputFeedback"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _utils = require("../../utils");
var _templateObject, _templateObject2;
const _excluded = ["children", "name", "label"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const defaultProps = {
  children: null,
  name: '',
  label: ''
};
function CheckboxGroup(props) {
  const _defaultProps$props = _objectSpread(_objectSpread({}, defaultProps), props),
    {
      children,
      name,
      label
    } = _defaultProps$props,
    restOfprops = _objectWithoutProperties(_defaultProps$props, _excluded);
  const {
    formState
  } = _Form.default.useForm();
  const fieldError = (0, _utils.getObjectField)(formState === null || formState === void 0 ? void 0 : formState.errors, name);
  const flatChildren = _react.default.Children.toArray(children).flat();
  return /*#__PURE__*/_react.default.createElement(Container, null, /*#__PURE__*/_react.default.createElement(StyledInputFeedback, {
    label: label,
    errors: fieldError,
    hasError: Boolean(fieldError === null || fieldError === void 0 ? void 0 : fieldError.message),
    name: name
  }, flatChildren === null || flatChildren === void 0 ? void 0 : flatChildren.map((child, index) => /*#__PURE__*/_react.default.isValidElement(child) ? /*#__PURE__*/_react.default.cloneElement(child, _objectSpread({
    key: child.key || index,
    name
  }, restOfprops)) : null)));
}
const Container = _styled.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
const StyledInputFeedback = (0, _styled.default)(_InputFeedback.default)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  & > label {\n    font-size: 10px;\n    font-weight: bold;\n    margin-bottom: 5px;\n  }\n"])));
var _default = exports.default = CheckboxGroup;